import { defaultFileInput, getFileMeta } from 'src/helpers'

export function SET_SELECTED_ROW (state, payload) {
  state.selectedRow = payload
}

export const INIT_FETCH_DATA = (state, value) => {
  state.initFetchData = value
}

export const SET_VALUE = (state, [key, value]) => {
  state[key] = value
}

export const SET_INITIAL_USER_RETAIL = (state, payload) => {
  state.userInformation = {
    ...state.userInformation,
    retail: {
      ...state.userInformation.retail,
      ...payload,
      image_ktp: {
        ...payload?.image_ktp,
        value: {
          ...defaultFileInput(),
          ...getFileMeta(payload?.image_ktp?.value),
          preview: payload?.image_ktp?.value
        }
      }
    }
  }
}

export const SET_INITIAL_USER_BUSINESS = (state, payload) => {
  const businessFormData = { ...payload }
  const tabs = ['companyInformation', 'directorInformation', 'secondDirectorInformation', 'spouseInformation']

  tabs.forEach(tab => {
    for (const tabData in businessFormData[tab]) {
      if (businessFormData[tab][tabData]?.isFile && businessFormData[tab][tabData]?.value) {
        if (businessFormData[tab][tabData]?.isMultipleFile) {
          businessFormData[tab][tabData] = {
            ...businessFormData[tab][tabData],
            value: businessFormData[tab][tabData]?.value?.map(file => ({
              ...defaultFileInput(),
              ...getFileMeta(file),
              preview: file
            }))
          }
        } else {
          businessFormData[tab][tabData] = {
            ...businessFormData[tab][tabData],
            value: {
              ...defaultFileInput(),
              ...getFileMeta(businessFormData[tab][tabData]?.value),
              preview: businessFormData[tab][tabData]?.value
            }
          }
        }
      }
    }
  })

  state.userInformation = {
    ...state.userInformation,
    business: {
      ...state.userInformation.business,
      ...businessFormData
    }
  }
}

export const SET_DOCS_GRADE_FILTER = (state, payload) => {
  if (state.docsGradeFilter?.includes(payload)) {
    state.docsGradeFilter = state.docsGradeFilter?.filter(item => item !== payload)
  } else {
    state.docsGradeFilter?.push(payload)
  }
}
